module.exports = __webpack_public_path__ + "static/logo-stacked-acc3ea0988e7bd5e5d1b52be8b837fc1.png";